import React from "react";

export default function WeatherFooter() {
  return (
    <footer>
      <a
        href="https://github.com/a-shapkina/react-weather-app"
        target="_blank"
        rel="noreferrer"
      >
        GitHub
      </a>{" "}
      © 2022{" "}
      <a href="https://ashapkina.com" target="_blank" rel="noreferrer">
        Alexandra Shapkina
      </a>
    </footer>
  );
}
